
import store from '@/vuex'

export default async(route) => {
	window.scrollTo(0, 0) // 跳转后返回页面顶部
	// 登录成功后的首次业务页进入完成后，再统一拉一次头部初始化数据，
	// 避免 beforeEach 重进过程中把同一批接口打两次。
	if (
		route.path !== '/aq/login' &&
		store.getters['route/postLoginInitPending']
	) {
		await store.dispatch('route/postLoginInit')
	}
}
